import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useState } from "react";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import Button from "react-bootstrap/Button";
import { createConnectionRequest } from "../../../Store/Thunk";
import { useDispatch } from "react-redux";

const ContactForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [company, setCompany] = useState("");
  const [title, setTitle] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [city, setCity] = useState("");
  const [message, setMessage] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isPhoneValid = /^(\+90|0)?5\d{9}$/.test(phoneNumber);

  const resetForm = () => {
    setName("");
    setSurname("");
    setCompany("");
    setTitle("");
    setEmail("");
    setPhoneNumber("");
    setCity("");
    setMessage("");
    setIsChecked(false);
  };

  const isFormValid =
    name.trim() &&
    surname.trim() &&
    company.trim() &&
    title.trim() &&
    isEmailValid &&
    isPhoneValid &&
    city.trim() &&
    message.trim() &&
    isChecked;

  return (
    <Row>
      <Col>
        <Row className={"justify-content-center fw-normal mb-3 "}>
          <Col>
            <Row className={"text-32 justify-content-center text-center gilroy-regular mb-2"}>
              <Col xs={"auto"}>{t("landing.contact.title")}</Col>
            </Row>
            <Row className={"text-24 justify-content-center text-center gilroy-thin"}>
              <Col xs={12} lg={8} xxl={6}>
                {t("landing.contact.subtitle")}
              </Col>
            </Row>
          </Col>
        </Row>

        <Form>
          <Row>
            <Col className={"gilroy-regular fw-normal text-22"}>
              <Row className={"justify-content-center "}>
                <Col xs={11} lg={5} xxl={4} className={"px-4 mb-3"}>
                  <Form.Label className={" mb-0"}> *{t("landing.contact.form.name")}</Form.Label>
                  <Form.Control
                    className={"default-text-input white-bg"}
                    style={{ height: "45px" }}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Col>
                <Col xs={11} lg={5} xxl={4} className={"px-4 mb-3"}>
                  <Form.Label className={" mb-0"}> *{t("landing.contact.form.surname")}</Form.Label>
                  <Form.Control
                    className={"default-text-input white-bg"}
                    style={{ height: "45px" }}
                    value={surname}
                    onChange={(e) => setSurname(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className={"justify-content-center "}>
                <Col xs={11} lg={5} xxl={4} className={"px-4 mb-3"}>
                  <Form.Label className={" mb-0"}> *{t("landing.contact.form.company")}</Form.Label>
                  <Form.Control
                    className={"default-text-input white-bg"}
                    style={{ height: "45px" }}
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                  />
                </Col>
                <Col xs={11} lg={5} xxl={4} className={"px-4 mb-3"}>
                  <Form.Label className={" mb-0"}> *{t("landing.contact.form.title")}</Form.Label>
                  <Form.Control
                    className={"default-text-input white-bg"}
                    style={{ height: "45px" }}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className={"justify-content-center  "}>
                <Col xs={11} lg={5} xxl={4} className={"px-4 mb-3"}>
                  <Form.Label className={" mb-0"}> *{t("landing.contact.form.email")}</Form.Label>
                  <Form.Control
                    className={"default-text-input white-bg"}
                    style={{ height: "45px" }}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {email && !isEmailValid && (
                    <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                      {t("landing.contact.form.emailError")}
                    </div>
                  )}
                </Col>
                <Col xs={11} lg={5} xxl={4} className={"px-4 mb-3"}>
                  <Form.Label className={" mb-0"}> *{t("landing.contact.form.phone")}</Form.Label>
                  <Form.Control
                    className={"default-text-input white-bg"}
                    style={{ height: "45px" }}
                    value={phoneNumber}
                    maxLength={13}
                    onChange={(e) => {
                      const input = e.target.value;
                      // Allow only digits and an optional starting "+" character
                      if (/^(\+)?\d*$/.test(input)) {
                        setPhoneNumber(input);
                      }
                    }}
                  />
                  {phoneNumber.trim() && !isPhoneValid && (
                    <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                      {t("landing.contact.form.phoneError")}
                    </div>
                  )}
                </Col>
              </Row>
              <Row className={"justify-content-center "}>
                <Col xs={11} lg={10} xxl={8} className={"px-4  mb-3"}>
                  <Form.Label className={" mb-0"}> *{t("landing.contact.form.city")}</Form.Label>
                  <Form.Control
                    className={"default-text-input white-bg"}
                    style={{ height: "45px" }}
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </Col>
              </Row>
              <Row className={"justify-content-center"}>
                <Col xs={11} lg={10} xxl={8} className={"px-4 mb-3"}>
                  <Form.Label className={" mb-0"}> *{t("landing.contact.form.message")}</Form.Label>
                  <Form.Control
                    className={"default-text-input white-bg"}
                    style={{ height: "45px" }}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </Col>
              </Row>

              <Row className={"justify-content-center"}>
                <Col xs={11} lg={10} xxl={8} className={"px-4 mb-4"}>
                  <Row>
                    <Col xs="auto">
                      <Form.Check
                        className="default-check-input"
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                      />
                    </Col>
                    <Col className="gilroy-thin text-20">{t("landing.contact.form.consentText")}</Col>
                  </Row>
                </Col>
              </Row>
              <Row className={"justify-content-center"}>
                <Col xs={"auto"} className={"mb-5"}>
                  <Button
                    className={"button primary primary-color gilroy-bold text-32"}
                    style={{ height: "70px", width: "240px", borderRadius: "15px" }}
                    onClick={() => {
                      const payload = {
                        Name: name,
                        Surname: surname,
                        City: city,
                        Company: company,
                        Title: title,
                        Email: email,
                        PhoneNumber: phoneNumber,
                        Domain: "cuspro",
                        Subject: message,
                      };

                      dispatch(createConnectionRequest(payload)).then(() => {
                        resetForm(); // clears the form after dispatch
                      });
                    }}
                    disabled={!isFormValid}
                  >
                    {t("landing.contact.form.submitButton")}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};
export default ContactForm;
